var _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateBusinessInternet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.912 16.102a9.608 9.608 0 0 0-5.834-2.768h-.043a9.536 9.536 0 0 0-5.834 2.768 1.928 1.928 0 0 0 0 2.725c.128.128.27.242.426.313a1.918 1.918 0 0 0 2.3-.313 5.715 5.715 0 0 1 3.136-1.604 5.724 5.724 0 0 1 5.011 1.604c.128.128.27.242.426.313a2.1 2.1 0 0 0 .412-.313 1.927 1.927 0 0 0 0-2.725zm5.436-5.437C23.211 7.53 19.18 5.869 15.063 5.641a17.175 17.175 0 0 0-11.299 5.024 1.928 1.928 0 0 0 0 2.726c.128.128.27.227.412.298.738.44 1.69.326 2.3-.298a13.474 13.474 0 0 1 8.573-3.918 13.45 13.45 0 0 1 10.462 3.918c.127.128.27.227.425.312a1.928 1.928 0 0 0 .412-3.038z",
    fill: "url(#q594e0z3ma)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.036 24.264a2.9 2.9 0 0 1-1.987 2.768 2.933 2.933 0 0 1-1.973-2.768c0-1.278.823-2.37 1.973-2.768a2.9 2.9 0 0 1 1.987 2.768z",
    fill: "url(#isafo033lb)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.354 9.274c-.553.426-1.079.88-1.59 1.377a1.928 1.928 0 0 0 0 2.725c.128.128.27.227.412.298.738.44 1.69.327 2.3-.298l.085-.085c-.98-1.065-1.377-2.583-1.207-4.031v.014z",
    fill: "url(#6dg97j6xrc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.748 14.91c-.553.34-1.079.709-1.561 1.192a1.928 1.928 0 0 0 0 2.725c.128.128.27.241.426.312a1.89 1.89 0 0 0 2.2-.241c-.909-1.079-1.264-2.57-1.079-3.989h.014z",
    fill: "url(#xfql6xtued)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.191 21.567s-.1-.057-.142-.072a2.933 2.933 0 0 0-1.973 2.768c0 1.278.823 2.371 1.973 2.768.227-.07.426-.198.61-.312-1.05-1.448-1.192-3.506-.468-5.138v-.014z",
    fill: "url(#tzcvjlvhwe)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.476 13.38c5.252-5.252 13.783-5.252 19.035 0a1.928 1.928 0 0 0 2.725-2.725c-6.757-6.743-17.73-6.743-24.472.014a1.928 1.928 0 0 0 2.726 2.725l-.014-.014zm5.436 5.437a5.766 5.766 0 0 1 8.162 0A1.928 1.928 0 0 0 22.8 16.09c-3.747-3.747-9.836-3.747-13.598 0a1.928 1.928 0 0 0 2.725 2.726h-.014z",
    stroke: "url(#ra8a5dwyqf)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.329a2.92 2.92 0 0 1 2.924 2.924A2.92 2.92 0 0 1 16 27.177a2.92 2.92 0 0 1-2.924-2.924A2.92 2.92 0 0 1 16 21.33z",
    stroke: "url(#z7zx1xj8ag)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "q594e0z3ma",
    x1: 20.795,
    y1: 38.492,
    x2: -2.662,
    y2: 28.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "isafo033lb",
    x1: 20.795,
    y1: 38.492,
    x2: -2.662,
    y2: 28.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6dg97j6xrc",
    x1: 12.445,
    y1: 36.552,
    x2: -1.176,
    y2: 32.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xfql6xtued",
    x1: 12.445,
    y1: 36.552,
    x2: -1.176,
    y2: 32.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tzcvjlvhwe",
    x1: 12.445,
    y1: 36.552,
    x2: -1.176,
    y2: 32.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra8a5dwyqf",
    x1: 22.196,
    y1: 38.737,
    x2: -2.557,
    y2: 27.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z7zx1xj8ag",
    x1: 22.196,
    y1: 38.737,
    x2: -2.557,
    y2: 27.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateBusinessInternet);
export default __webpack_public_path__ + "static/media/corporateBusinessInternet.a90f06e06bc68322f9c70293866e0e96.svg";
export { ForwardRef as ReactComponent };